import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, ChevronLeftIcon, ChevronRightIcon, ZoomInIcon, ArrowLeftIcon } from 'lucide-react';
interface GalleryPageProps {
  onNavigate: (page: string) => void;
  initialIndex?: number;
}
const ALL_IMAGES = [{
  url: 'https://cdn.magicpatterns.com/uploads/kz8rhY5ZFL3afPmoLdfTj6/IMG-20250203-WA0002.jpg',
  caption: 'Letecký pohled na areál a město Žlutice'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/g9Js7824QWNHMaLnV96npj/20260110_135324.jpg',
  caption: 'Interiér výrobní haly'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/rQNTQgt7KREVKpGzy1XWyB/20260110_135334.jpg',
  caption: 'Výrobní prostory s regály'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/wgSDBnrqaxxzF2WNihwwiv/20260102_192350.jpg',
  caption: 'Noční pohled na areál'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/3VToVwxypuTMGqY5qyipri/20251217_113431.jpg',
  caption: 'Areál v denním světle'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/cutUXFvXwjrjTeD1C75Zzd/20251217_111204.jpg',
  caption: 'Dvůr areálu s nákladní technikou'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/2VMoDjJ6oDqKWPuGH7oM9t/20260125_174005.jpg',
  caption: 'Interiér s klenbovými stropy'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/ePNRusS1sTQFAngBHEsKFN/20260131_121202.jpg',
  caption: 'Probíhající rekonstrukce interiéru'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/fzpQGnUJczzHE9wthkUeti/20260110_135353.jpg',
  caption: 'Prostorná výrobní hala'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/dg3njcj91eaHoQSZeKDiQp/20260104_155209.jpg',
  caption: 'Areál v zimním období'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/vxCs7JyHuepXzLHVyygNMR/20260110_135317.jpg',
  caption: 'Výrobní hala s velkými okny'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/nFYaGTmKdrp8Pa7C64yxAw/WhatsApp_Image_2026-03-19_at_16.08.39.jpg',
  caption: 'Pohled na výrobní haly a přilehlé budovy'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/wUnnUfLRi4FavWm17UTUmZ/WhatsApp_Image_2026-03-19_at_16.08.50.jpg',
  caption: 'Dvůr areálu s příjezdem pro nákladní vozidla'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/iL2DDQoZeUPRR2975WAD1J/WhatsApp_Image_2026-03-19_at_16.09.04.jpg',
  caption: 'Detail fasády výrobní haly'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/3zp9vG4VZLiX6VUDeoGPw5/WhatsApp_Image_2026-03-19_at_16.09.35.jpg',
  caption: 'Celkový pohled na dvůr a výrobní haly'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/ovWC3CPzGAQU3WhNxJmbEU/WhatsApp_Image_2026-03-19_at_16.07.43.jpg',
  caption: 'Noční pohled na areál'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/3yBKcEkmiuA5j2BnYTFh35/2.jpg',
  caption: 'Interiér haly s nákladním vozidlem'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/isikUmmGKC7DeaDufpwAvY/20251009_191125.jpg',
  caption: 'Večerní pohled na areál'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/8NkEZSkRsEFQNTsoVNC4CE/20251009_183932.jpg',
  caption: 'Areál v podvečer'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/fizC1XD9iUoAxXgkEDe6GF/20250921_183523.jpg',
  caption: 'Západ slunce nad areálem'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/ojQYg1nXX6H8zdfQpKSaEf/20250920_114245.jpg',
  caption: 'Bagr při stavebních pracích'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/cf6JyCmpYfSQXfNeY6vWmd/WhatsApp_Image_2026-03-19_at_16.09.26.jpg',
  caption: 'Budova areálu v zimním období'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/5ej1GwA28Mm5qTFf3VAqmN/WhatsApp_Image_2026-03-19_at_16.10.00_(3).jpg',
  caption: 'Hlavní budova areálu s nakladačem'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/7ACiGjecu1L8QreMsFd6SD/WhatsApp_Image_2026-03-19_at_16.10.01.jpg',
  caption: 'Přeprava těžké techniky v areálu'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/m7NoNQjwMnijgW5YiySNny/100.jpg',
  caption: 'Plán areálu s vyznačenými objekty a plochami'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/xk4dHTtfH8Xhk87BvonXhT/20251217_100242.jpg',
  caption: 'Nákladní vozidlo s velkým nákladem v areálu'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/p4bzGNQNycrq3FrazhUx7A/20251209_173337.jpg',
  caption: 'Interiér výrobní haly s vysokými stropy'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/uw6tBcoDqyjQcdrFpyDbs9/20251122_155818.jpg',
  caption: 'Prostorná výrobní hala s moderním osvětlením'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/jLHkfFwQ5RRSk5UCt5p6K6/20251014_115509.jpg',
  caption: 'Bagr při stavebních pracích v areálu'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/jvQXVqY8s9VdrdLLwBzUjq/20251011_145919.jpg',
  caption: 'Celkový pohled na areál s okolní zástavbou'
}];
export function GalleryPage({
  onNavigate,
  initialIndex
}: GalleryPageProps) {
  const [selectedIndex, setSelectedIndex] = useState<number | null>(initialIndex ?? null);
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (selectedIndex === null) return;
      if (e.key === 'Escape') setSelectedIndex(null);
      if (e.key === 'ArrowLeft') showPrev(e as unknown as React.MouseEvent);
      if (e.key === 'ArrowRight') showNext(e as unknown as React.MouseEvent);
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedIndex]);
  const openLightbox = (index: number) => setSelectedIndex(index);
  const closeLightbox = () => setSelectedIndex(null);
  const showPrev = (e: React.MouseEvent) => {
    e?.stopPropagation();
    if (selectedIndex !== null) {
      setSelectedIndex(selectedIndex === 0 ? ALL_IMAGES.length - 1 : selectedIndex - 1);
    }
  };
  const showNext = (e: React.MouseEvent) => {
    e?.stopPropagation();
    if (selectedIndex !== null) {
      setSelectedIndex(selectedIndex === ALL_IMAGES.length - 1 ? 0 : selectedIndex + 1);
    }
  };
  return <div className="min-h-screen bg-neutral-950 text-slate-300 pt-24 pb-12" data-id="element-287">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-288">
        {/* Header */}
        <div className="mb-12" data-id="element-289">
          <button onClick={() => onNavigate('home')} className="inline-flex items-center text-slate-400 hover:text-[#e0a812] transition-colors mb-8" data-id="element-290">
            <ArrowLeftIcon className="w-5 h-5 mr-2" data-id="element-291" />
            Zpět na hlavní stránku
          </button>
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-292">
            Galerie areálu
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-xl text-slate-400" data-id="element-293">
            Prohlédněte si fotografie komerčního areálu ve Žluticích
          </motion.p>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-24" data-id="element-294">
          {ALL_IMAGES.map((img, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: index * 0.05
        }} className={`relative group cursor-pointer overflow-hidden rounded-sm bg-neutral-900 ${index === 0 ? 'sm:col-span-2 lg:col-span-2 row-span-2' : ''}`} onClick={() => openLightbox(index)} data-id="element-295">
              <div className="aspect-w-16 aspect-h-10 w-full h-full min-h-[250px]" data-id="element-296">
                <img src={img.url} alt={img.caption} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 opacity-90 group-hover:opacity-100" data-id="element-297" />
              </div>
              <div className="absolute inset-0 bg-neutral-950/0 group-hover:bg-neutral-950/40 transition-colors duration-300 flex items-center justify-center" data-id="element-298">
                <ZoomInIcon className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300 w-10 h-10" data-id="element-299" />
              </div>
              <div className="absolute bottom-0 left-0 right-0 px-4 pb-5 pt-10 bg-gradient-to-t from-neutral-950/90 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-300">
                <p className="text-neutral-300 text-xs font-medium" data-id="element-301">
                  {img.caption}
                </p>
              </div>
            </motion.div>)}
        </div>

        {/* CTA */}
        <div className="text-center pb-12" data-id="element-302">
          <h2 className="text-2xl font-bold text-white mb-6" data-id="element-303">
            Zaujal vás tento areál?
          </h2>
          <button onClick={() => {
          onNavigate('home');
          setTimeout(() => {
            const el = document.getElementById('kontakt');
            if (el) el.scrollIntoView({
              behavior: 'smooth'
            });
          }, 100);
        }} className="inline-flex items-center justify-center px-8 py-4 text-lg font-medium text-neutral-950 bg-[#e0a812] hover:bg-[#c4920f] transition-colors rounded-sm" data-id="element-304">
            Kontaktujte nás
          </button>
        </div>
      </div>

      {/* Lightbox Modal */}
      <AnimatePresence data-id="element-305">
        {selectedIndex !== null && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-[100] bg-neutral-950/95 flex items-center justify-center backdrop-blur-sm" onClick={closeLightbox} data-id="element-306">
            <button className="absolute top-6 right-6 text-slate-400 hover:text-white transition-colors z-50 p-2" onClick={closeLightbox} aria-label="Zavřít galerii" data-id="element-307">
              <XIcon className="w-8 h-8" data-id="element-308" />
            </button>

            <button className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 hover:text-white transition-colors z-50 p-2 bg-neutral-900/50 rounded-full hover:bg-neutral-800" onClick={showPrev} aria-label="Předchozí obrázek" data-id="element-309">
              <ChevronLeftIcon className="w-8 h-8" data-id="element-310" />
            </button>

            <button className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 hover:text-white transition-colors z-50 p-2 bg-neutral-900/50 rounded-full hover:bg-neutral-800" onClick={showNext} aria-label="Další obrázek" data-id="element-311">
              <ChevronRightIcon className="w-8 h-8" data-id="element-312" />
            </button>

            <div className="relative max-w-7xl w-full max-h-[90vh] px-12" onClick={e => e.stopPropagation()} data-id="element-313">
              <motion.img key={selectedIndex} initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.3
          }} src={ALL_IMAGES[selectedIndex].url} alt={ALL_IMAGES[selectedIndex].caption} className="w-full h-full object-contain max-h-[90vh] mx-auto rounded-sm shadow-2xl" data-id="element-314" />
              <div className="absolute -bottom-14 left-0 right-0 text-center" data-id="element-315">
                <p className="text-neutral-400 text-sm" data-id="element-316">
                  {ALL_IMAGES[selectedIndex].caption}
                </p>
                <p className="text-neutral-600 text-xs mt-1" data-id="element-317">
                  {selectedIndex + 1} / {ALL_IMAGES.length}
                </p>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}